import { render, staticRenderFns } from "./main.vue?vue&type=template&id=82a7a12a&"
import script from "./main.vue?vue&type=script&lang=js&"
export * from "./main.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\公司文件\\web\\uni-platform\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('82a7a12a')) {
      api.createRecord('82a7a12a', component.options)
    } else {
      api.reload('82a7a12a', component.options)
    }
    module.hot.accept("./main.vue?vue&type=template&id=82a7a12a&", function () {
      api.rerender('82a7a12a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "组件/Admin/src/router/layouts/main.vue"
export default component.exports